import React from 'react';
import LayersHeading from 'components/customComponents/Layers/LayersHeading';

function AdvanceOptions({ headingText, children, style = null }) {
  return (
    <div id="commandpanel-advanceoptions-wrapper" className="flex flex-column flex-space-between" style={style}>
      <LayersHeading text={headingText} />
      {children}
    </div>
  );
}

export default AdvanceOptions;
